//deprecated
angular.module('dpw.directives')
    .directive('dpwHMenus', ['dpwEvents', 'helpers', 'menuService', function (dpwEvents, helpers, menuService) {
        return {
            restrict: 'A',
            scope: {},
            replace: true,
            templateUrl: 'dpw-hMenus.html',
            controller: ['$scope', '$element', '$attrs', '$location', 'helpers', function ($scope, $element, $attrs, $location, helpers) {
                var self = this;
                self.clickHandler = function (item, parentItem, $event) {
                    $event.preventDefault();
                    if (helpers.isNewTabKey($event) && !angular.isFunction(item.handler)) {
                        window.open(item.href || ('#' + item.path), '_blank');
                        return;
                    }
                    parentItem = parentItem || {};
                    angular.isDefined(item.href) && (window.location.href = item.href);
                    angular.isDefined(item.path) && ($location.path(item.path));
                    angular.isFunction(item.handler) && item.handler();
                    if (angular.isDefined(item.path)) {
                        traverse($scope.menuItems, function (item, parentItem) {
                            item.isSelected = false;
                        });
                        parentItem.isSelected = item.isSelected = true;
                    }
                };
                self.getHref = function (item) {
                    if (angular.isDefined(item.href)) {
                        return item.href;
                    }
                    if (angular.isDefined(item.path)) {
                        return '#' + item.path;
                    }
                };
                self.setExpanded = function (expanded, item) {
                    angular.isObject(item) && (item.isExpanded = expanded);
                };
                self.isSep = function (item) {
                    return item === '|';
                };
                function init() {
                    var selectedItemParent = null;
                    traverse($scope.menuItems, function (item, parentItem) {
                        item.isSelected = isSelected(item);
                        item.isSelected && (selectedItemParent = parentItem);
                    });
                    // updating selectedItemParent should wait to avoid conflict with 'item.isSelected = false;'
                    selectedItemParent && (selectedItemParent.isSelected = true);

                }

                self.isShowMenu = function (item) {
                    return RCDPW.isLogin || !item.requireLogin;
                };
                $scope.$on(dpwEvents.hMenusUpdate, renderMenu);
                renderMenu();
                function renderMenu() {
                    $scope.menuItems = menuService.getHMenus();
                    init();
                }

                function traverse(arr, callback, parent) {
                    $.each(arr, function (idx, item) {
                        item.items && traverse(item.items, callback, item);
                        callback(item, parent);
                    });
                }

                function isSelected(item) {
                    if (item.href) {
                        return (window.location.pathname == item.href) || matchAPIExplorerPages();
                    } else if (item.path) {
                        return ($location.path() == item.path);
                    }
                    function matchAPIExplorerPages() {
                        return helpers.isAPIExplorerPages(window.location.pathname) &&
                            helpers.isAPIExplorerPages(item.href);
                    }
                }
            }],
            controllerAs: 'hMenusCtrl'
        };
    }]);